import { LoginUsersService } from "src/app/Services/login-users.service";
import { Injectable, Inject, PLATFORM_ID } from "@angular/core";
import {
    HttpEvent,
    HttpInterceptor,
    HttpHandler,
    HttpRequest,
    HttpResponse,
    HttpErrorResponse,
} from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { map, catchError, finalize } from "rxjs/operators";
import "rxjs/Observable";
import "rxjs/add/operator/do";
import "rxjs/add/observable/throw";
import "rxjs/add/operator/catch";
import "rxjs/add/operator/finally";
import "rxjs/add/operator/map";
import { Router } from "@angular/router";
import { isPlatformBrowser } from "@angular/common";
import { EmbryoService } from "./Embryo.service";
import { StaticPagesService } from "./static-pages.service";
import { environment } from "../../environments/environment.prod";
import { MetaService } from "./meta-data.service";
import { EMPTY } from "rxjs";

@Injectable()
export class AppInterceptor implements HttpInterceptor {
    pendingRequests: number = 0;
    userLang: string | string[] = "";
    environmentVariables: any;
    lang: any;

    constructor(
        public auth: LoginUsersService,
        private router: Router,
        private loginUsersService: LoginUsersService,
        private embryoService: EmbryoService,
        @Inject(PLATFORM_ID) private platformId: Object,
        private pagesService: StaticPagesService,
        private metaService: MetaService
    ) {
        this.pagesService.getenvConfig().subscribe((res) => {
            if (res) {
                this.environmentVariables = res;
            }
        });
        this.embryoService.emitLang.subscribe((lang: any) => {
            this.lang = lang;
        });
    }

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        this.pendingRequests++;
        let url = req.url;

        if (isPlatformBrowser(this.platformId)) {
            localStorage.getItem("lang") == "en"
                ? (this.userLang = "1")
                : (this.userLang = "2");
            if (
                this.auth.getToken() &&
                !url.includes("s3") &&
                !url.includes("social_signup")
            ) {
                if (this.environmentVariables) {
                    // if (
                    //     (this.auth.isGuest() && !this.auth.getUser()?.is_guest &&
                    //         url ==
                    //             environment.api +
                    //                 `/api/customer/profile/addresses`) ||
                    //     (this.auth.isGuest() && !this.auth.getUser()?.is_guest &&
                    //         url ==
                    //             environment.api +
                    //                 `/api/customer/orders/delivery_fees`) ||
                    //     (this.auth.isGuest() && !this.auth.getUser()?.is_guest &&
                    //         url ==
                    //             environment.api +
                    //                 `/api/customer/orders/check_promo_v2`) ||
                    //     (this.auth.isGuest() && !this.auth.getUser()?.is_guest &&
                    //         url == environment.api + `/api/customer/orders`) ||
                    //     (this.auth.isGuest() && !this.auth.getUser()?.is_guest &&
                    //         url ==
                    //             environment.api +
                    //                 `/api/customer/profile/resend_verification`)
                    // ) {
                    //     req = req.clone({
                    //         setHeaders: {
                    //             lang: this.userLang,
                    //             "x-admin-preview":
                    //                 window.location.href.includes(
                    //                     "skip_maintenance"
                    //                 ) ||
                    //                 localStorage.getItem("skip_maintenance")
                    //                     ? "1"
                    //                     : "0",
                    //         },
                    //     });
                    // } else {
                        req = req.clone({
                            setHeaders: {
                                lang: this.userLang,
                                Authorization: `Bearer ${this.auth.getToken()}`,
                                "x-admin-preview":
                                    window.location.href.includes(
                                        "skip_maintenance"
                                    ) ||
                                    localStorage.getItem("skip_maintenance")
                                        ? "1"
                                        : "0",
                            },
                        });
                    // }
                } else {
                    if (this.auth.isGuest()) {
                        req = req.clone({
                            setHeaders: {
                                lang: this.userLang,
                                "x-admin-preview":
                                    window.location.href.includes(
                                        "skip_maintenance"
                                    ) ||
                                    localStorage.getItem("skip_maintenance")
                                        ? "1"
                                        : "0",
                            },
                        });
                    } else {
                        req = req.clone({
                            setHeaders: {
                                lang: this.userLang,
                                Authorization: `Bearer ${this.auth.getToken()}`,
                                "x-admin-preview":
                                    window.location.href.includes(
                                        "skip_maintenance"
                                    ) ||
                                    localStorage.getItem("skip_maintenance")
                                        ? "1"
                                        : "0",
                            },
                        });
                    }
                }
            } else {
                req = req.clone({
                    setHeaders: {
                        lang: this.userLang,
                        "x-admin-preview":
                            window.location.href.includes("skip_maintenance") ||
                            localStorage.getItem("skip_maintenance")
                                ? "1"
                                : "0",
                    },
                });
            }
        }

        //send the newly created request
        return next.handle(req).pipe(
            map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    if (event.body.code == 700) {
                        const lang: string = localStorage.getItem("lang") ? localStorage.getItem("lang") as string : "en" ;
                        this.embryoService.Emitlanguage(lang);
                        if (
                            !window.location.href
                                .toString()
                                .includes("/under-construction")
                        ) {
                            this.router.navigate([
                                "/" + this.lang + "/under-construction",
                            ]);
                            this.pagesService.setenvConfigOfflineApp(
                                event.body
                            );
                        }
                        if (this.lang == "en")
                            this.metaService.setTitle(
                                `${
                                    event.body?.message_en ||
                                    "Website Under Construction"
                                }`
                            );
                        else
                            this.metaService.setTitle(
                                `${
                                    event.body?.message_ar ||
                                    "الموقع تحت الانشاء"
                                }`
                            );
                    }

                    if (
                        event.body.code == 200 &&
                        window.location.href
                            .toString()
                            .includes("/under-construction")
                    ) {
                        this.router.navigate(["/" + this.lang]);
                    }

                    if (event.status === 401 || event.body.code === 401) {
                        this.auth.removeToken();
                        this.router.navigate([
                            "/" + this.lang + "/session/signin",
                        ]);
                        this.embryoService.favouritesListSub.next([]);
                        this.embryoService.compareListSub.next([]);
                        this.embryoService.guestProductsCart = [];
                        this.embryoService.productCartSub.next([]);
                        this.loginUsersService.logOut();
                        document
                            .getElementById("html")
                            ?.classList.remove("admin-panel");
                        // this.router.navigate(['/']);
                        this.embryoService.store([]);
                    }
                }
                return event;
            }),
            catchError((err: HttpErrorResponse) => {
                if (err.status === 401) {
                    this.auth.removeToken();
                    return EMPTY;
                } else {
                    return EMPTY;
                }
            }),
            finalize(() => this.pendingRequests--) as any
        );
    }
}
